import { push } from "connected-react-router";
import PropTypes from "prop-types";
import React, { Component } from "react";
import DocumentTitle from "react-document-title";
import { connect } from "react-redux";

import { userSelectors } from "../../nav/selectors";
import { resourceTypes, roles } from "../actions";
import PoliciesTable from "../components/PoliciesTable";
import ResourcesList from "../components/ResourcesList";
import ServicesList from "../components/ServicesList";
import {
  EntityShape,
  PolicyShape,
  ProductShape,
  ResourceShape,
  ResourceTypeShape,
  RoleShape,
  ServiceShape
} from "../proptypes";
import selectors from "../selectors";
import PoliciesSummary from "./PoliciesSummary";

class Policies extends Component {
  title = "RBAC - Policies";

  state = {
    sortBy: "group"
  };

  getSortedEntities = () => {
    const { sortBy } = this.state;
    const {
      entitiesByGroup,
      entitiesByUser,
      entitiesByName,
      entitiesByDomain
    } = this.props;

    switch (sortBy) {
      case "group":
        return entitiesByGroup;
      case "user":
        return entitiesByUser;
      case "name":
        return entitiesByName;
      case "domain":
        return entitiesByDomain;
      default:
        return entitiesByGroup;
    }
  };

  setSortState = option => {
    this.setState({ sortBy: option });
  };

  openScopes = uri => {
    const { push, setCurrentResourceType } = this.props;
    if (uri) {
      setCurrentResourceType(uri);
    }
    push("/policies/scopes");
  };

  render() {
    const { sortBy } = this.state;
    const {
      loadingProducts,
      loadingPolicies,
      loadingServices,
      loadingResources,
      loadingResourceTypes,
      services,
      resources,
      currentResource,
      resourceTypes,
      roles,
      policies,
      products,
      savingPolicies,
      canEditServices,
      canEditUsers
    } = this.props;
    const entities = this.getSortedEntities();

    return (
      <div>
        <DocumentTitle title={this.title} />
        <div className="l-policies">
          <ServicesList
            products={products}
            services={services}
            loading={loadingProducts || loadingServices}
            canEdit={canEditServices}
          />
          <ResourcesList
            resources={resources}
            resourceTypes={resourceTypes}
            loading={loadingResources || loadingResourceTypes}
            openScopesModal={this.openScopes}
          />
          <PoliciesTable
            entities={entities}
            policies={policies}
            roles={roles}
            openRoles={this.openRoles}
            canEditUsers={canEditUsers}
            disabled={!currentResource || savingPolicies || loadingPolicies}
            sortBy={sortBy}
            setSortState={this.setSortState}
          />
          <PoliciesSummary openRoles={this.openRoles} />
        </div>
      </div>
    );
  }
}

Policies.defaultProps = {
  currentResource: undefined
};

Policies.propTypes = {
  push: PropTypes.func.isRequired,
  loadingProducts: PropTypes.bool.isRequired,
  loadingPolicies: PropTypes.bool.isRequired,
  loadingServices: PropTypes.bool.isRequired,
  loadingResources: PropTypes.bool.isRequired,
  loadingResourceTypes: PropTypes.bool.isRequired,
  services: PropTypes.arrayOf(ServiceShape).isRequired,
  resources: PropTypes.arrayOf(ResourceShape).isRequired,
  currentResource: ResourceShape,
  resourceTypes: PropTypes.arrayOf(ResourceTypeShape).isRequired,
  setCurrentResourceType: PropTypes.func.isRequired,
  entitiesByGroup: PropTypes.arrayOf(EntityShape).isRequired,
  entitiesByUser: PropTypes.arrayOf(EntityShape).isRequired,
  entitiesByName: PropTypes.arrayOf(EntityShape).isRequired,
  entitiesByDomain: PropTypes.arrayOf(EntityShape).isRequired,
  roles: PropTypes.arrayOf(RoleShape).isRequired,
  policies: PropTypes.arrayOf(PolicyShape).isRequired,
  savingPolicies: PropTypes.bool.isRequired,
  products: PropTypes.arrayOf(ProductShape).isRequired,
  canEditServices: PropTypes.bool.isRequired,
  canEditUsers: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  loadingProducts: state.products.loading,
  loadingPolicies: state.policies.loading,
  loadingServices: state.services.loading,
  loadingResources: state.resources.loading,
  loadingResourceTypes: state.resourceTypes.loading,
  entitiesByGroup: selectors.entities.getByGroup(state),
  entitiesByUser: selectors.entities.getByUser(state),
  entitiesByName: selectors.entities.getByName(state),
  entitiesByDomain: selectors.entities.getByDomain(state),
  roles: selectors.roles.get(state),
  services: selectors.services.getFiltered(state),
  resources: selectors.resources.getByCurrentProduct(state),
  currentResource: selectors.resources.getCurrent(state),
  resourceTypes: selectors.resourceTypes.getFiltered(state),
  policies: selectors.policies.getInScope(state),
  savingPolicies: state.policies.saving,
  products: selectors.products.getFiltered(state),
  canEditServices: userSelectors.canEditServices(state),
  canEditUsers: userSelectors.canEditUsers(state)
});

const mapDispatchToProps = {
  setCurrentRole: roles.setCurrent,
  setCurrentResourceType: resourceTypes.setCurrent,
  push
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Policies);
